<!--
  VisibilityField — visibility renderer; the chrome-free inner GridCell hosts.
  Wraps the pill picker (VisibilityButton): picking a pill emits `update:modelValue`
  then `commit` (the control is the whole cell — no separate edit surface, so
  `mode` doesn't branch here).
-->
<template>
  <div class="visibility-field">
    <VisibilityButton
      :model-value="visibility"
      :field="field"
      :readonly="!editable"
      @update:model-value="onSelect"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import type { Field } from "@auger/core/fields"
import { type FieldMode, type FieldSize } from "../useField"
import VisibilityButton from "./VisibilityButton.vue"

const props = withDefaults(
  defineProps<{
    modelValue: unknown
    field: Field
    mode: FieldMode
    size?: FieldSize
  }>(),
  { size: "small" }
)

const emit = defineEmits<{
  "update:modelValue": [value: unknown]
  commit: [payload?: { advance?: boolean }]
  cancel: []
}>()

const editable = computed(() => !!props.field.isEditable)
const visibility = computed(() => props.modelValue as string | null)

// Picking a pill commits immediately (interaction persists; no advance).
function onSelect(value: string) {
  emit("update:modelValue", value)
  emit("commit")
}
</script>

<style>
.visibility-field {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
